import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "User Activity", -1)
const _hoisted_5 = { class: "text-muted fs-7" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = {
  key: 2,
  class: "activity-list"
}
const _hoisted_10 = { class: "activity-icon" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-coin" }, null, -1)
const _hoisted_14 = { class: "text-muted fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, "User #" + _toDisplayString(_ctx.userId), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Loading activity..."))
        : (_ctx.activities.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, "No activity found."))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayActivities, (activity, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "activity-item d-flex align-items-start gap-3 mb-4"
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.getActivityIcon(activity))
                    }, null, 2)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.buildActivityText(activity)
                    }, null, 8, _hoisted_11),
                    (activity.coinBalance !== undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _hoisted_13,
                          _createTextVNode(" " + _toDisplayString(activity.coinBalance.toLocaleString()) + " coins ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatActivityDate(activity.date)), 1)
                  ])
                ]))
              }), 128))
            ]))
    ])
  ]))
}